// extracted by mini-css-extract-plugin
export var actions = "_k8-d";
export var benefitCard = "_k8-a";
export var benefitIcon = "_k8-b";
export var benefitLabel = "_k8-c";
export var benefits = "_k8-9";
export var bodyText = "_k8-8";
export var closeButton = "_k8-2";
export var content = "_k8-3";
export var eyebrow = "_k8-4";
export var heading = "_k8-5";
export var image = "_k8-f";
export var imagePanel = "_k8-e";
export var modal = "_k8-0";
export var shell = "_k8-1";
export var title = "_k8-6";
export var titleOffer = "_k8-7";